import { render, staticRenderFns } from "./combined-sales-by-brand.vue?vue&type=template&id=edf12d6c&scoped=true"
import script from "./combined-sales-by-brand.vue?vue&type=script&lang=js"
export * from "./combined-sales-by-brand.vue?vue&type=script&lang=js"
import style0 from "./combined-sales-by-brand.vue?vue&type=style&index=0&id=edf12d6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf12d6c",
  null
  
)

export default component.exports